import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, Table, TableBody, TableCell, TableRow, Typography, lighten, makeStyles } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import clsx from 'clsx';
import { mapServiceToTransactionList } from 'components/ServiceCard/ServiceCard.types';
import { adjustTransactionState } from 'pages/CustomerBooking/RecoilState';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import ReactJson from 'react-json-view';
import { useRecoilState } from 'recoil';
import { getServices } from 'services/service.service';
import { localizeCurrency } from 'util/localizeFormat';
import { toasterror } from 'util/toasterror';

const useStyles = makeStyles(theme => ({
  accordionSummaryRoot: {
    flexDirection: 'row-reverse',
    margin: '0 !important',
    padding: 0,
    minHeight: 'unset !important',
  },
  accordionSummaryExpandIcon: {
    marginRight: 'unset',
  },
  accordionDetailsRoot: {
    paddingLeft: 0,
    paddingRight: 0,

  },
  accordionRoot: {
    boxShadow: theme.shadows[0],
  },
  noBorder: {
    borderBottom: 'none',
  },
  accordionSummaryContent: {
    margin: '0 !important',
    paddingRight: theme.spacing(2),
  },
  expanded: {
    margin: '0 !important',
    minHeight: 'unset !important',
    height: 'auto !important'
  },
  strike: {
    color: theme.palette.text.secondary,
    textDecoration: 'line-through'
  },
  toggleCell: {
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'flex-start'
  },
  removeButton: {
    width: 'auto',
    color: theme.palette.error.main,
    backgroundColor: lighten(theme.palette.error.light, 0.75),
    '&:hover': {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.contrastText,
    }
  }
}));
const CartTable = ({
  cartTable,
  readOnly = false,
}) => {
  const classes = useStyles()

  const [adjustTransaction, setAdjustTransaction] = useRecoilState(adjustTransactionState);

  const enableItem = useCallback(
    (item) => {
      const newExtendedPackageItems = adjustTransaction?.extended_package_items?.map((extendedPackageItem) => {
        return {
          ...extendedPackageItem,
          disabled: extendedPackageItem?.item?.id === item?.id ? false : extendedPackageItem?.disabled
        }
      })
      setAdjustTransaction({
        ...adjustTransaction,
        extended_package_items: newExtendedPackageItems
      })
    },
    [adjustTransaction],
  );
  const disableItem = useCallback(
    (item) => {
      const newExtendedPackageItems = adjustTransaction?.extended_package_items?.map((extendedPackageItem) => {
        return {
          ...extendedPackageItem,
          disabled: extendedPackageItem?.item?.id === item?.id ? true : extendedPackageItem?.disabled
        }
      })
      const disabledCount = newExtendedPackageItems?.filter((extendedPackageItem) => !extendedPackageItem?.disabled)?.length
      if (disabledCount === 0) {
        toasterror('At least one item must be enabled')
        return
      }
      setAdjustTransaction({
        ...adjustTransaction,
        extended_package_items: newExtendedPackageItems
      })
    },
    [adjustTransaction],
  );
  const renderToggleItem = useCallback(
    (item) => {
      if (readOnly) return (<></>)
      if (item?.isWhitelabelCovered) {
        return <></>
      }

      const cartItemCount = cartTable?.reduce((acc, curr) => {
        return acc + curr?.items?.length
      }, 0)

      const singleItemInCart = cartItemCount === 1

      return (
        <Button
          className={clsx(item.disabled ? null : classes.removeButton)}
          variant={'contained'}
          color={item.disabled ? 'primary' : 'secondary'}
          size='small'
          disabled={singleItemInCart}
          onClick={() => {
            if (item.disabled) {
              enableItem(item)
            } else {
              disableItem(item)
            }
          }}>{item.disabled ? 'Add' : 'Remove'}</Button>
      )

    },
    [cartTable],
  );

  return (
    <>
      {cartTable?.map((pkg, index) => {
        return (
          <Accordion
            key={`accdrn-${index}`}
            classes={{
              root: classes.accordionRoot,
              expanded: classes.expanded,
            }}
            defaultExpanded={!pkg?.package?.fee}>
            <AccordionSummary
              classes={{
                root: classes.accordionSummaryRoot,
                expandIcon: classes.accordionSummaryExpandIcon,
                content: classes.accordionSummaryContent,
                expanded: classes.expanded,
              }}
              IconButtonProps={{
                size: 'small',
                disableRipple: true,
              }}
              expandIcon={<ExpandMore />}>
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%'
              }}>
                <Typography variant="body2"> {pkg?.package?.label} </Typography>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>{pkg?.package?.fee ? localizeCurrency(pkg?.package?.fee):'-'}</Typography>
              </div>
            </AccordionSummary>
            <AccordionDetails classes={{
              root: classes.accordionDetailsRoot,
            }}>
              <Table size='small'>
                <TableBody>
                  {pkg?.items?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell align='left'>
                          <Typography variant='body2' color='textSecondary' className={clsx(item?.disabled && classes.strike)}>
                            {item?.label}
                          </Typography>
                          {renderToggleItem(item)}
                        </TableCell>
                        <TableCell variant="head" align="right" className={clsx(item?.isInPackage && classes.strike)}>
                          {item?.fee && localizeCurrency(item?.fee)}
                        </TableCell>

                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion >
        )
      })}
    </>
  )
}

export { CartTable }